import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Navbar from './components/Navbar';

import Footer from './components/Footer';
// import Home from './pages/Home';

import About from './pages/About';
import Contact from './pages/Contact';

import Services from './pages/Services';
import './App.css';
//import Privacy from './pages/Privacy';
import TermsService from './pages/TermsService';
import Support from './pages/Support';
import PrivacyPolicy from './pages/PrivacyPolicy';

import Header from './components/Header';
import Home from './pages/Home';



function App() {
  return (
    <div className="App">
      <Router>
      <Header/>
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsService />} />
           <Route path="/support" element={<Support/>} />
         </Routes>
      
     

      <Footer />
    </Router>
    </div>
  );
}

export default App;
